import React, { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_all, fetch_all_with_count, fetch_one } from "../../../../lib/v31lib";
// import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import {
  Grid,
  Paper,
} from '@mui/material';

import {
  Button,
  Typography
} from '../../../../components/v2/styled';

import { User } from '../../../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  object: User;
  mutationCustomAction: any;
  passResetLink?: string;
  passResetEmail?: string;
}

// Title + explanation keys mirror the `weight_trigger` entry in the actions
// widget's ACTION_RENDER map, and the row styling mirrors its ActionRow
// primitive: subtitle2 title + caption explanation (text.secondary) + a
// fullwidth outlined button below. Kept consistent so the standalone
// weight_trigger widget reads like its twin row in actions (the actions
// widget's h5 "Actions" header has no standalone equivalent here — the
// subtitle2 title is the title, no duplicated h5+Divider card header).
const TITLE_KEY = 'coach.submenu.detail.weight_trigger';
const EXPLANATION_KEY = 'coach.submenu.detail.weight_trigger_explanation';

export const CoachUserWidgetsWeightTrigger: FunctionComponent<Props> = ({
  object,
  mutationCustomAction
}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const params = useParams();
  // const queryClient = useQueryClient();
  // const { state } = useLocation();
  // const [searchParams, setSearchParams] = useSearchParams();

  // Two runtime states (no weight trigger yet, or this practice already owns
  // it), each with its own CTA. They collapse to the same title/explanation +
  // a fullwidth enable/disable button — the actions widget's weight_trigger
  // row renders the exact same pair via ACTION_RENDER.
  const trigger = object.extra_data?.weight_trigger;
  const notYet = !trigger;
  const ownedByUs = !!trigger && trigger === currentPractice?.id;

  return <>
    {(notYet || ownedByUs) && <Paper sx={{padding: 2, marginTop: 1}}>
      <Grid container spacing={1} sx={{position: 'relative'}}>
        <Grid item xs={12} sx={{marginTop: 1}}>
          <Typography variant="subtitle2" html>{t(TITLE_KEY)}</Typography>
          <Typography variant="caption" html sx={{display: 'block', color: 'text.secondary', marginBottom: 0.5}}>{t(EXPLANATION_KEY)}</Typography>
          {notYet && <Button
            label={t("coach.general.actions.enable_weight_trigger")}
            id='enable_weight_trigger'
            fullwidth
            sx={{marginTop: 0}}
            onClick={(v) => {
              mutationCustomAction.mutate({formData: {
                object: 'user',
                class_action: 'custom_api_weight_trigger',
                id: object?.id,
                practice_id: currentPractice?.id
              }, mfa: true});
            }}
          />}
          {ownedByUs && <Button
            label={t("coach.general.actions.disable_weight_trigger")}
            id='disable_weight_trigger'
            fullwidth
            sx={{marginTop: 0}}
            onClick={(v) => {
              mutationCustomAction.mutate({formData: {
                object: 'user',
                class_action: 'custom_api_weight_trigger',
                id: object?.id,
                practice_id: currentPractice?.id,
                disable: 1
              }, mfa: true});
            }}
          />}
        </Grid>
      </Grid>
    </Paper>}
  </>;
}
